import { createRouter, createWebHashHistory } from 'vue-router';
import App from './App.vue';
import authStore from './core/services/authStore/authStore';

const routes = [
    {
        path: '/',
        name: 'App',
        component: App,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: 'Dashboard',
                component: () => import('./components/home/Dashboard.vue')
            },
            {
                path: 'library',
                name: 'Library',
                component: () => import('./components/home/Library.vue')
            },
            {
                path: 'notification',
                name: 'Notification',
                children: [
                    {
                        path: 'email/promotional',
                        name: 'Promotional Email Tool',
                        component: () => import('./components/notification/PromotionalCampaign.vue')
                    },
                    {
                        path: 'email/promotional/campaigns',
                        name: 'Promotional Email Campaigns',
                        component: () => import('./components/notification/FindCampaign.vue')
                    }
                ]
            },
            {
                path: 'cms',
                name: 'cms',
                children: [
                    {
                        path: 'policy/update',
                        name: 'Customize Policy Content',
                        component: () => import('./components/cms/PolicyUpdate.vue')
                    }
                ]
            },
            {
                path: 'company',
                name: 'Company',
                children: [
                    {
                        path: 'add',
                        name: 'Add New Company',
                        component: () => import('./components/company/CompanyAddEdit')
                    },
                    {
                        path: 'modify',
                        name: 'Modify Company',
                        component: () => import('./components/company/CompanyAddEdit')
                    },
                    {
                        path: 'all/info',
                        name: 'List All Company Info',
                        component: () => import('./components/company/CompanyAllInfo')
                    },
                    {
                        path: 'all/info/:companyId',
                        name: 'List Company Info',
                        props: true,
                        meta: { validPath : '/company/all/info'},
                        component: () => import('./components/company/CompanyAllInfo')
                    },
                    {
                        path: 'contact/add',
                        name: 'Add Company Contact',
                        component: () => import('./components/company/CompanyContactAddEdit')
                    },
                    {
                        path: 'contact/modify/:companyName/:companyId/:id/',
                        name: 'Modify Company Contact',
                        props: true,
                        meta: { validPath : '/company/contact/modify'},
                        component: () => import('./components/company/CompanyContactAddEdit')
                    },
                    {
                        path: 'contact/find',
                        name: 'Find Company Contact',
                        component: () => import('./components/company/CompanyContactFind')
                    },
                    {
                        path: 'notification/settings',
                        name: 'Company Notification Settings',
                        component: () => import('./components/company/CompanyNotificationSettings')
                    },
                    {
                        path: 'contact/notification/settings/:contactId/:locationId/:companyName',
                        name: 'Company Contact Notification Settings',
                        props: true,
                        meta: { validPath : '/company/contact/notification/settings'},
                        component: () => import('./components/company/CompanyContactNotificationSettings')
                    },
                    {
                        path: 'location/add',
                        name: 'Add Location',
                        component: () => import('./components/company/CompanyLocationAddEdit')
                    },
                    {
                        path: 'location/edit/:id',
                        name: 'Modify Location',
                        props: true,
                        meta: { validPath : '/company/location/edit'},
                        component: () => import('./components/company/CompanyLocationAddEdit')
                    },
                    {
                        path: 'location/find',
                        name: 'Find Location',
                        component: () => import('./components/company/CompanyLocationFind')
                    },
                    {
                        path: 'list/all',
                        name: 'List All Companies',
                        component: () => import('./components/company/CompanyListAll')
                    },
                    {
                        path: 'location/list/all',
                        name: 'List Company Locations',
                        component: () => import('./components/company/CompanyLocationListAll')
                    }
                ]
            },
            {
                path: 'student',
                name: 'Student',
                children: [
                    {
                        path: 'find',
                        name: 'Find A Student',
                        component: () => import('./components/student/StudentFind.vue')
                    },
                    {
                        path: 'edit/:studentId',
                        name: 'Edit Student Information',
                        props: true,
                        meta: { validPath: '/student/edit'},
                        component: () => import('./components/student/StudentEdit.vue')
                    },
                    {
                        path: 'reset/password',
                        name: 'Reset Password By Admin',
                        component: () => import('./components/student/StudentFind.vue')
                    },
                    {
                        path: 'loginas',
                        name: 'Find A Student To Login',
                        component: () => import('./components/student/StudentFind.vue')
                    },
                    {
                        path: 'login-details/:type',
                        name: 'Student Login Details',
                        props: true,
                        meta : { validPath : '/student/login-details' },
                        component: () => import('./components/student/StudentLoginDailyWeekly.vue')
                    },
                    {
                        path: 'mailing-list/add',
                        name: 'Add A Student To Mailing List',
                        component: () => import('./components/student/StudentAddToMailingList.vue')
                    }
                ]
            },
            {
                path: 'class',
                name: 'Class',
                children: [
                    {
                        path: 'add/add_spreadsheet',
                        name: 'Add Classes Spreadsheet',
                        component: () => import('./components/class/ClassAddSpreadsheet')
                    },
                    {
                        path: 'add',
                        name: 'Add Class',
                        component: () => import('./components/class/ClassAddEdit')
                    },
                    {
                        path: 'search/:action',
                        name: 'Search Class',
                        props: true,
                        meta : { validPath : '/class/search' },
                        component: () => import('./components/class/ClassSearch')
                    },
                    {
                        path: 'modify_class/:id/:companyId',
                        name: 'Modify Class',
                        props: true,
                        meta : { validPath : '/class/modify_class' },
                        component: () => import('./components/class/ClassAddEdit')
                    },
                    {
                        path: 'view_changes/:id/:companyId',
                        name: 'View Class Changes',
                        props: true,
                        meta : { validPath : '/class/view_changes' },
                        component: () => import('./components/class/ViewClassChanges')
                    },
                    {
                        path: 'enrollment_report/:id/:companyId',
                        name: 'Enrollment Report',
                        props: true,
                        meta : { validPath : '/class/enrollment_report' },
                        component: () => import('./components/class/EnrollmentReport')
                    },
                    {
                        path: 'modify_attendance/:id/:companyId',
                        name: 'Modify Attendance',
                        props: true,
                        meta : { validPath : '/class/modify_attendance' },
                        component: () => import('./components/class/ModifyAttendance')
                    },
                    {
                        path: 'modify_roster/:id/:companyId',
                        name: 'Modify Class Roster',
                        props: true,
                        meta : { validPath : '/class/modify_roster' },
                        component: () => import('./components/class/ModifyClassRoaster')
                    },
                    {
                        path: 'poster_report/:jsonData',
                        name: 'Poster Report',
                        props: (route) => ({ jsonData: JSON.parse(route.params.jsonData) }),
                        meta : { validPath : '/class/poster_report' },
                        component: () => import('./components/class/PosterReport')
                    },
                    {
                        path: 'status_email/:jsonData',
                        name: 'Class Status Emails',
                        props: (route) => ({ jsonData: JSON.parse(route.params.jsonData) }),
                        meta : { validPath : '/class/status_email' },
                        component: () => import('./components/class/StatusEmail')
                    },
                    {
                        path: 'webcast_material/upload',
                        name: 'Upload Webcast Materials',
                        component: () => import('./components/class/UploadWebcastMaterial')
                    },
                    {
                        path: 'webcast_material/upload/:topicId/:companyId?',
                        name: 'Upload Webcast Material of Topic',
                        props: true,
                        meta : { validPath : '/class/webcast_material/upload' },
                        component: () => import('./components/class/UploadWebcastMaterial')
                    }
                ]
            },
            {
                path: 'topic',
                name: 'Topic',
                children: [
                    {
                        path: 'add',
                        name: 'Add Class Topic',
                        component: () => import('./components/topic/TopicAddEdit')
                    },
                    {
                        path: 'edit/:topicId',
                        name: 'Modify Class Topic',
                        props: true,
                        meta : { validPath : '/topic/edit' },
                        component: () => import('./components/topic/TopicAddEdit')
                    },
                    {
                        path: 'list/all',
                        name: 'List All Class Topics',
                        component: () => import('./components/topic/TopicListAll')
                    },
                    {
                        path: 'category/add',
                        name: 'Add Class Topic Category',
                        component: () => import('./components/topic/TopicCategoryAddEdit')
                    },
                    {
                        path: 'category/edit/:id',
                        name: 'Modify Class Topic Category',
                        props: true,
                        meta : { validPath : '/topic/category/edit' },
                        component: () => import('./components/topic/TopicCategoryAddEdit')
                    },
                    {
                        path: 'category/list',
                        name: 'List Class Topic Category',
                        component: () => import('./components/topic/TopicCategoryList')
                    },
                    {
                        path: 'exam/copy',
                        name: 'Copy Questions',
                        component: () => import('./components/topic/TopicQuestionsCopy')
                    },
                    {
                        path: 'exam/copy/:topicId',
                        name: 'Copy Questions With Topic',
                        props: true,
                        meta: { validPath: '/topic/exam/copy' },
                        component: () => import('./components/topic/TopicQuestionsCopy')
                    },
                    {
                        path: 'add/exam/:topicId',
                        name: 'Initialize Exam',
                        props: true,
                        meta : { validPath : '/topic/add/exam' },
                        component: () => import('./components/topic/TopicExam')
                    }
                ]
            },
            {
                path: 'report',
                name: 'Report',
                children: [
                    {
                        path: 'copy/orderby',
                        name: 'Copy Order By Instructor',
                        component: () => import('./components/report/CopyInstructorReport')
                    },
                    {
                        path: 'instructor',
                        name: 'Instructor Report',
                        component: () => import('./components/report/InstructorReport')
                    },
                    {
                        path: 'instructor/class',
                        name: 'Instructor Class Report',
                        component: () => import('./components/report/InstructorClassReport')
                    },
                    {
                        path: 'instructor/payroll',
                        name: 'Instructor Payroll Report',
                        component: () => import('./components/report/InstructorPayrollReport')
                    },
                    {
                        path: 'invoice',
                        name: 'Invoice Report',
                        component: () => import('./components/report/InvoiceReport')
                    },
                    {
                        path: 'revenue',
                        name: 'Revenue Report',
                        component: () => import('./components/report/RevenueReport')
                    },
                    {
                        path: 'weekly-worksheet',
                        name: 'Weekly Worksheet',
                        component: () => import('./components/report/WeeklyWorksheet')
                    },
                    {
                        path: 'video-clicks',
                        name: 'Video Clicks Report',
                        component: () => import('./components/report/VideoClicksReport')
                    },
                    {
                        path: 'video-list',
                        name: 'Teams Video List',
                        component: () => import('./components/report/VideoClicksList')
                    }
                ]
            },
            {
                path: 'admin',
                name: 'Admin',
                children: [
                    {
                        path: 'add',
                        name: 'Add Tool User',
                        component: () => import('./components/admin/AdminAddEdit')
                    },
                    {
                        path: 'edit/:adminId',
                        name: 'Modify Tool User',
                        props: true,
                        meta: { validPath: '/admin/edit' },
                        component: () => import('./components/admin/AdminAddEdit')
                    },
                    {
                        path: 'list/toolusers', 
                        name: 'Tool Users List',
                        component: () => import('./components/admin/AdminList') 
                    },
                    {
                        path: 'clienttool/login',
                        name: 'Login to Client Tools',
                        component: () => import('./components/admin/LoginToClientTool')
                    },
                    {
                        path: 'company/fee/settings',
                        name: 'Company Fee Settings',
                        component: () => import('./components/admin/CompanyFeeSettings')
                    },
                    {
                        path: 'student/page/settings',
                        name: 'Student Page Settings',
                        component: () => import('./components/admin/StudentPageSettings')
                    },
                    {
                        path: 'general/settings',
                        name: 'General Settings',
                        component: () => import('./components/admin/GeneralSettings')
                    },
                    {
                        path: 'email/tool',
                        name: 'Customize Email Tool',
                        component: () => import('./components/notification/CustomEmail.vue')
                    }
                ]
            },
            {
                path: 'calendar',
                name: 'Calendar',
                children: [
                    {
                        path: 'view',
                        name: 'Calendar View',
                        component: () => import('./components/calendar/CalendarView')
                    },
                    {
                        path: 'search',
                        name: 'Search Calendar',
                        component: () => import('./components/calendar/CalendarSearch')
                    }
                ]
            }
        ]
    },
    {
        path: '/auth',
        name: 'Auth',
        component: App,
        meta: { guest: true },
        children: [
            {
                path: 'login',
                name: 'Login',
                meta: { guest: true },
                component: () => import('./auth/Login.vue')
            },
            {
                path: 'forgot-password',
                name: 'Forgot Password',
                meta: { guest: true },
                component: () => import('./auth/ForgotPassword.vue')
            },
            {
                path: 'reset-password/:email',
                name: 'Reset Password',
                meta: { guest: true },
                props: true,
                component: () => import('./auth/ResetPassword.vue')
            }
        ]
    },
    {
        path: '/error',
        name: 'Error',
        component: () => import('./auth/errorHandling/Error.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'Page not found',
        component: () => import('./auth/errorHandling/NotFound.vue')
    },
    {
        path: '/access',
        name: 'Access',
        component: () => import('./auth/errorHandling/Access.vue')
    },
    {
        path: '/class/assignment_report/:id/:companyId',
        name: 'Instructor Assignment Sheet',
        props: true,
        meta : { validPath : '/class/assignment_report' },
        component: () => import('./components/class/InstructorAssignmentReport')
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach( async (to, from, next) => {
    document.title = `Financial Knowledge Admin | ${to.name}`;
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (authStore.getters.isAuthenticated && authStore.getters.userToken) {
            const fullPath = to.fullPath;
            const validPath = to.meta.validPath;
            const pathsAllowed = await authStore.getters.paths;
            if (pathsAllowed?.includes(fullPath) || !pathsAllowed || pathsAllowed?.includes(validPath)) {
                next();
            } else {
                next('/access');
            }
            return;
        }
        next("/auth/login");
    }
    else if (to.matched.some((record) => record.meta.guest)) {
        if (authStore.getters.isAuthenticated && authStore.getters.userToken) {
            next('/');
            return;
        }
        next();
    }
    else{
        next();
    }
});

export default router;
